// extracted by mini-css-extract-plugin
module.exports = {"sellPointsModule":"Third_sellPointsModule__Upi8h"};